import {
  colors,
  media,
  NewTypography,
  radius,
  spacing,
} from '@lamimed/pantheon';
import Image from 'next/image';
import styled, { Attrs, css, RuleSet } from 'styled-components';

type Style = Attrs;

const isMobileSmallWidth =
  () =>
  (style: Style, ...rest: RuleSet) => {
    return css`
      @media (max-width: 350px) {
        ${style && css(style, ...rest)}
      }
    `;
  };

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${spacing.small};

  ${isMobileSmallWidth()`
    grid-template-columns: 1fr;
  `};
`;

export const FounderImage = styled(Image)`
  width: 100%;
  height: 100%;
  border-top-left-radius: ${radius.small};
  border-top-right-radius: ${radius.small};
  object-fit: cover;
  object-position: top;

  ${isMobileSmallWidth()`
    width: 15rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top-left-radius: ${radius.small};
    border-bottom-left-radius: ${radius.small};
  `};
`;

export const Card = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.light};
  border-radius: ${radius.small};

  ${isMobileSmallWidth()`
    max-height: 8rem;
    flex-direction: row;
  `};

  ${media.greaterThan('tablet')`
    align-items: flex-start;
  `}
`;

export const Typography = styled(NewTypography)`
  &:first-child {
    font-size: 1rem;
  }

  &:nth-child(2) {
    font-size: 1.2rem;
  }

  ${isMobileSmallWidth()`
    &:first-child {
      font-size: 1.4rem;
    }
  `};

  ${media.greaterThan('tablet')`
    &:first-child {
      font-size: 1.8rem;
    }

    &:nth-child(2) {
      font-size: 1.6rem;
    }
  `};
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${spacing.small} ${spacing.none};

  ${isMobileSmallWidth()`
    margin-left: ${spacing.small};
    align-items: flex-start;
  `};
`;
